/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Google's event type: ordinary meetings versus the status-style entries
(working location, out of office, focus time, birthdays) Google renders
and notifies differently. Immutable at the provider after creation.
 */
export type EventType = (typeof EventType)[keyof typeof EventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventType = {
  default: 'default',
  out_of_office: 'out_of_office',
  focus_time: 'focus_time',
  working_location: 'working_location',
  birthday: 'birthday',
  from_gmail: 'from_gmail',
} as const;
